/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";
import { NonNegativeInteger } from "@pagopa/ts-commons/lib/numbers";

export enum Payment_modelEnum {
  "IMMEDIATE" = "IMMEDIATE",

  "IMMEDIATE_MULTIBENEFICIARY" = "IMMEDIATE_MULTIBENEFICIARY",

  "DEFERRED" = "DEFERRED",

  "ACTIVATED_AT_PSP" = "ACTIVATED_AT_PSP"
}

export enum ProtocolEnum {
  "HTTPS" = "HTTPS",

  "HTTP" = "HTTP"
}

export enum Redirect_protocolEnum {
  "HTTPS" = "HTTPS",

  "HTTP" = "HTTP"
}

// required attributes
const ChannelDetailsR = t.interface({
  agid: t.boolean,

  broker_psp_code: t.string,

  card_chart: t.boolean,

  channel_code: t.string,

  digital_stamp_brand: t.boolean,

  enabled: t.boolean,

  flag_psp_cp: t.boolean,

  flag_standin: t.boolean,

  on_us: t.boolean,

  payment_model: enumType<Payment_modelEnum>(
    Payment_modelEnum,
    "payment_model"
  ),

  port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ]),

  primitive_version: t.Integer,

  protocol: enumType<ProtocolEnum>(ProtocolEnum, "protocol"),

  recovery: t.boolean,

  rt_push: t.boolean,

  thread_number: t.Integer,

  timeout_a: NonNegativeInteger,

  timeout_b: NonNegativeInteger,

  timeout_c: NonNegativeInteger
});

// optional attributes
const ChannelDetailsO = t.partial({
  broker_description: t.string,

  flag_io: t.boolean,

  ip: t.string,

  new_fault_code: t.boolean,

  nmp_service: t.string,

  password: t.string,

  proxy_enabled: t.boolean,

  proxy_host: t.string,

  proxy_password: t.string,

  proxy_port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ]),

  proxy_username: t.string,

  redirect_ip: t.string,

  redirect_path: t.string,

  redirect_port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ]),

  redirect_protocol: enumType<Redirect_protocolEnum>(
    Redirect_protocolEnum,
    "redirect_protocol"
  ),

  redirect_query_string: t.string,

  serv_plugin: t.string,

  service: t.string,

  target_host: t.string,

  target_host_nmp: t.string,

  target_path: t.string,

  target_path_nmp: t.string,

  target_port: t.Integer,

  target_port_nmp: t.Integer
});

export const ChannelDetails = t.intersection(
  [ChannelDetailsR, ChannelDetailsO],
  "ChannelDetails"
);

export type ChannelDetails = t.TypeOf<typeof ChannelDetails>;
